<template>
  <div class="container" :style="{padding:paddingNum}">

    <!--頭部-->
    <div class="profileHead">
      <div class="myAccount">
        <span class="account">
          {{ $t('mall_profile.my_account') }}<!-- 我的帳戶 -->
        </span>
        <span>
         {{ $t('mall_profile.welcome') }} <!-- 歡迎回來 -->
        </span>
      </div>
      <div class="pointer logOut" @click="logout">
        {{ $t('mall_home.logout') }}<!-- 退出登錄 -->
      </div>
    </div>

    <div class="changeBox">
      <!--左邊-->
      <div class="leftBox">
        <div class="profileMenu" ref="profileMenu">
          <router-link exact active-class="active" @click.native="routerRefresh" :to="{path:'/profile/self-page'}">
            <img style="width: 26px;height: 26px;" :src="require('@/assets/homeImg/home_wdzh_icon_gerenxinxi@2x.png')"
                 alt="">
            <span>
              {{ $t('mall_profile.user_infor') }}<!-- 個人信息 -->
            </span>
          </router-link>
        </div>
        <div class="profileMenu" ref="profileMenus">
          <router-link to="/profile/my-order">
            <img style="width: 23px;height: 26px;" :src="require('@/assets/homeImg/home_wdzh_icon_wddd@2x.png')" alt="">
            <span>
              {{ $t('mall_profile.my_order') }}<!-- 我的訂單 -->
            </span>
          </router-link>
        </div>
        <div class="profileMenu" ref="profileMenu">
          <router-link to="/profile/shopping-cart">
            <img style="width: 26px;height: 30px;" :src="require('@/assets/img/product_list/profile_shopping_cart.png')"
                 alt="">
            <span>
              {{ $t('mall_profile.my_cart') }}<!-- 我的購物袋 -->
            </span>

          </router-link>
        </div>
      </div>

      <!--右邊-->
      <div class="rightBox">
        <router-view/>
      </div>

    </div>


  </div>
</template>

<script>
export default {
  name: "Profile",
  beforeRouteEnter(to, from, next) {
    var token = localStorage.getItem('Authorization');
    // console.log("this.$store.token",  localStorage.getItem('Authorization'));
    if (token !== null && token !== "") {
      next()
    } else {
      next('/login')
    }
  },
  data() {
    return {
      imgurl: require('@/assets/homeImg/home_img_n&p@2x.png'),
      imagesList: [
        require('@/assets/homeImg/banner-汇丰-HK@2x.png'),
        require('@/assets/homeImg/home_img_n&p@2x.png'),
        require('@/assets/homeImg/banner-汇丰-HK@2x.png'),
      ],
      itemW: 0,
      mr: '',
      paddingNum: '',
      active: 'active',
      index: 0,
      routerAlive: true
    }
  },
  methods: {
    routerRefresh() {
      this.routerAlive = false;
      this.$nextTick(() => {
        this.routerAlive = true;
      });
    },
    changeImage: function (index) {
      this.imgurl = this.imagesList[index];
    },
    goTo() {
      this.$router.push('/self-page')
    },
    logout() {
      this.$store.dispatch('Logout').then(() => {
        window.location.reload()
      });
    },
  },
  mounted() {
  },
  created() {
  }
}
</script>

<style scoped>

.profileHead {
  color: #979694;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  padding: 50px 0 14px 0;
  margin-bottom: 30px;
}

.account {
  color: #1E1303;
  font-size: 22px;
}

.changeBox {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 5px;
}

.leftBox {
  font-size: 16px !important;
  width: 20%;
  height: 20%;
  /*border: 1px solid #ddd;*/
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, .3);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, .3);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, .3);
  padding: 38px 32px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.profileMenu {
  height: 50px;
  /*background-color: #F7F5F1;*/
  margin-bottom: 10px;
  /*padding-left: 10px;*/
  color: #3E3C39;
  display: flex;
  flex-direction: row;
  align-items: center;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.profileMenu {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.profileMenu > a {
  padding-left: 10px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom: 1px solid #ddd;
}

.active {
  background-color: #F7F5F1;
  border-bottom: none !important;
}

.profileMenu img {
  width: 26px;
  height: 26px;
  margin-right: 10px;
}

.rightBox {
  width: 75%;
  padding: 30px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  min-height: 906px;
  overflow: hidden;
  position: relative;
  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, .1);
  -moz-box-shadow: 0 0 5px 0 rgba(0, 0, 0, .1);
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, .1);
  margin-bottom: 20px;
}

.logOut {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/viewHK/Profile.vue